import { useMemo } from 'react';
import { useApiQuery } from './useApiQuery';
import { filesApi } from '@/api/files';
import type { FileFilters, FileListResponse, FileRecord } from '@/api/files';
import mockData from '@/data/mock-data.json';

interface UseFilesOptions {
  filters?: FileFilters;
  enabled?: boolean;
}

export const useFiles = (options: UseFilesOptions = {}) => {
  const { filters = {}, enabled = true } = options;

  const mockFiles = useMemo<FileListResponse>(() => ({
    files: mockData.files as FileRecord[],
    total: mockData.files.length,
  }), []);

  const { data, isLoading, error, isUsingMockData, reload } = useApiQuery<FileListResponse>(
    {
      queryFn: () => filesApi.listFiles(filters),
      mockData: mockFiles,
      enabled,
    },
    [
      filters.direction,
      filters.status,
      filters.search,
      filters.starred,
      filters.deleted,
      filters.page,
      filters.limit,
    ],
  );

  return {
    files: data?.files ?? [],
    total: data?.total ?? 0,
    isLoading,
    error,
    isUsingMockData,
    reload,
  };
};
